// extracted by mini-css-extract-plugin
export default {"text":"DateWithColorWarnings_text__OHBr4","warning":"DateWithColorWarnings_warning__+q0Pe","danger":"DateWithColorWarnings_danger__1NiDI"};